let elems = document.querySelectorAll('[data-bg-image]');

for (let key in elems) {
    if (elems.hasOwnProperty(key)) {
        let el = elems[key];

        let currentStyle = el.getAttribute('style');

        if (currentStyle !== null)
            currentStyle = currentStyle + ';';
        else
            currentStyle = '';

        el.setAttribute('style', currentStyle + 'background-image: url("' + el.getAttribute('data-bg-image') + '")');
    }
};
